import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute'; // 导入ProtectedRoute
import Home from './pages/Home/Home';
import ProjectsList from './pages/Projects/ProjectsList';
import ProjectDetail from './pages/Projects/ProjectDetail';
import UserLogin from './pages/Users/UserLogin';
import UserRegister from './pages/Users/UserRegister';
import UserDetail from './pages/Users/UserDetail';
import UserEdit from './pages/Users/UserEdit';
import UserAppointment from './pages/Users/UserAppointment';
import UserMobileRegister from './pages/Users/UserMobileRegister';
import ServiceListPage from './pages/Services/ServiceListPage';
import ServicePage from './pages/Services/ServicePage';
import TechnicianPage from './pages/Technicians/TechnicianPage';
import TechnicianAll from './pages/Technicians/TechnicianAll';
import ServiceItemPage from './pages/Services/ServiceItemPage';
import BookingPage from './pages/Booking/BookingPage';
import PaymentPage from './pages/Booking/PaymentPage';
import PaymentDone from './pages/Booking/PaymentDone';
import PaymentFail from './pages/Booking/PaymentFail';
import Footer from './components/Footer';
import UserCenter from './pages/Users/UserCenter';
import Recharge from './pages/Users/Recharge';
import VipSubscription from './pages/Users/VipSubscription';
import GiftCards from './pages/Users/GiftCards';
import Favorites from './pages/Users/Favorites';
import AppointmentForm from './pages/Appointment/AppointmentForm';
import UserEmailRegister from './pages/Users/UserEmailRegister';
import UnifiedLogin from './pages/Users/UnifiedLogin';
import GoogleLogin from './components/GoogleLogin';




const AppRoutes = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/projects" element={<ProjectsList />} />
        <Route path="/projects/:id" element={<ProjectDetail />} />
        <Route path="/uplogin" element={<UserLogin />} />
        <Route path="/register" element={<UserRegister />} />
        
        {/* 需要登录保护的用户相关页面 */}
        <Route path="/users/:id" element={
          <ProtectedRoute>
            <UserDetail />
          </ProtectedRoute>
        } />
        <Route path="/users/:id/edit" element={
          <ProtectedRoute>
            <UserEdit />
          </ProtectedRoute>
        } />
        <Route path="/appointments" element={
          <ProtectedRoute>
            <UserAppointment />
          </ProtectedRoute>
        } />
        <Route path="/user-appointment" element={
          <ProtectedRoute>
            <UserAppointment />
          </ProtectedRoute>
        } />
        <Route path="/user-center" element={
          <ProtectedRoute>
            <UserCenter />
          </ProtectedRoute>
        } />
        <Route path="/recharge" element={
          <ProtectedRoute>
            <Recharge />
          </ProtectedRoute>
        } />
        <Route path="/vip-subscription" element={
          <ProtectedRoute>
            <VipSubscription />
          </ProtectedRoute>
        } />
        <Route path="/gift-cards" element={
          <ProtectedRoute>
            <GiftCards />
          </ProtectedRoute>
        } />
        <Route path="/favorites" element={
          <ProtectedRoute>
            <Favorites />
          </ProtectedRoute>
        } />
        <Route path="/user/bookings" element={
          <ProtectedRoute>
            <UserAppointment />
          </ProtectedRoute>
        } />
        
        <Route path="/mobileregister" element={<UserMobileRegister />} />
        <Route path="/services/:categoryId" element={<ServiceListPage />} />
        <Route path="/service/:serviceId" element={<ServiceItemPage />} />
        <Route path="/technician/:technicianId" element={<TechnicianPage />} />
        <Route path="/technicians" element={<TechnicianAll />} />
        
        {/* 需要登录保护的预约和支付相关页面 */}
        <Route path="/booking/:technicianId" element={
          <ProtectedRoute>
            <BookingPage />
          </ProtectedRoute>
        } />
        <Route path="/payment" element={
          <ProtectedRoute>
            <PaymentPage />
          </ProtectedRoute>
        } />
        <Route path="/paymentdone" element={
          <ProtectedRoute>
            <PaymentDone />
          </ProtectedRoute>
        } />
        
        <Route path="/paymentfail" element={<PaymentFail />} />
        <Route path="/appointmentform" element={<AppointmentForm />} />
        <Route path="/emailregister" element={<UserEmailRegister />} />
        <Route path="/login" element={<UnifiedLogin />} /> 
        <Route path="/googlelogin" element={<GoogleLogin />} /> 

        <Route path="*" element={<div>Page Not Found</div>} />
      </Routes>
      <Footer />
    </Router>
  );
};

export default AppRoutes;
